/**
 * Renders human-readable copy for a notification's platform-owned `type`
 * (APP_SPEC §32). Purely presentational — the *type* itself is generated
 * entirely by the platform from session progression and social events
 * (never game-specific — CLAUDE.md §2), and this function's job is only to
 * turn that fixed vocabulary into a sentence.
 */
export function notificationMessage(type: string, actorUsername: string | null): string {
  const actor = actorUsername ?? 'Someone';
  switch (type) {
    case 'friend.request_received':
      return `${actor} sent you a friend request.`;
    case 'friend.request_accepted':
      return `${actor} accepted your friend request.`;
    case 'game.invitation_received':
      return `${actor} invited you to a game.`;
    case 'game.invitation_accepted':
      return `${actor} accepted your game invitation.`;
    case 'game.invitation_declined':
      return `${actor} declined your game invitation.`;
    case 'game.your_turn':
      return "It's your turn.";
    case 'game.opponent_moved':
      return `${actor} made a move.`;
    case 'game.completed':
      return 'A game you played in has completed.';
    case 'game.forfeited':
      return `${actor} forfeited the game.`;
    default:
      return 'You have a new notification.';
  }
}
